/**
 * @desc 根据sku产品id查询单个产品信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductMasterResponseDto>;
export function request(skuKey: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productSku/bySkuKey/${skuKey}`, {
      method: "GET",

      ...options,
    }),
  );
}
